/** 装飾は読み上げ対象外にし、募集情報は必ずHTMLテキストで表示します。 */
export function PaperPins() {
  return (
    <span className="jq-paper-pins" aria-hidden="true">
      <i />
      <i />
    </span>
  );
}

/** 紙の依頼書に押された「技術の書」の紋章。外部画像やフォントに依存しません。 */
export function QuestInsignia() {
  return (
    <svg
      className="jq-quest-insignia"
      viewBox="0 0 160 130"
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      <circle
        cx="80"
        cy="65"
        r="54"
        stroke="currentColor"
        strokeWidth="1"
        strokeDasharray="2 5"
        opacity=".45"
      />
      <path
        d="M25 36c20-7 38-5 55 5 17-10 35-12 55-5v64c-20-7-38-5-55 5-17-10-35-12-55-5V36Z"
        fill="currentColor"
        opacity=".12"
      />
      <path
        d="M25 36c20-7 38-5 55 5 17-10 35-12 55-5v64c-20-7-38-5-55 5-17-10-35-12-55-5V36Zm55 5v64"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinejoin="round"
      />
      <path
        d="m57 52-13 13 13 13m46-26 13 13-13 13M88 49 73 84"
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="square"
        strokeLinejoin="miter"
      />
      <path
        d="M80 8v10m-5-5h10M16 73H6m5-5v10m138-33h-10m5-5v10"
        stroke="currentColor"
        strokeWidth="2"
        opacity=".6"
      />
    </svg>
  );
}
